import { IState } from "./index"

export default {
  getState (state: IState): IState {
    return state
  }
};